import React, { Component, KeyboardEvent, ReactNode, createRef, useEffect, useState } from 'react';
import { Collapse, Input, Spin, Tabs, TabsProps, Timeline, Tooltip, Select } from 'antd';
import { inject, observer } from 'mobx-react';
// @ts-ignore
import withRouter from '@/components/withRouter';
// @ts-ignore
import ViewSource, { ViewSourceType as Detail } from '@/components/ViewSource';
// @ts-ignore
import { Display } from '@/components/Display/Display';
import { cloneDeep } from 'lodash';
import 'react-photo-view/dist/react-photo-view.css';
import {
    aiDetail,
    fileDetail,
    updateTitle,
    getTranslation,
    getTranslationStatus,
    getDelete,
    Request,
    RequestResult
} from '../../../../../../api/fileManagement';
// @ts-ignore
import './index.scss';
import { AimOutlined, VerticalAlignTopOutlined, LeftOutlined, SyncOutlined, ExclamationCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
// @ts-ignore
import ai_content from '@/assets/images/tw/ai_content.png';
// @ts-ignore
import ai_replay from '@/assets/images/tw/replay.png';
// @ts-ignore
import person1 from '@/assets/images/tw/person1.png';
// @ts-ignore
import person2 from '@/assets/images/tw/person2.png';
// @ts-ignore
import person3 from '@/assets/images/tw/person3.png';
// @ts-ignore
import person4 from '@/assets/images/tw/person4.png';
// @ts-ignore
import fadeIn from '@/assets/images/tw/fade-in.png';
// @ts-ignore
import fadeOut from '@/assets/images/tw/fade-out.png';
// @ts-ignore
import point from '@/assets/images/tw/point.png';
// @ts-ignore
import ai_title from '@/assets/images/tw/ai_title.png';
// @ts-ignore
import Toast from '@/components/Toast';
import { PhotoSlider } from 'react-photo-view';
import { languageOptionsInfo } from '../dict';
// @ts-ignore
import { ConfirmTip } from '../madalConfirm';
import TextExpand from './utils';
import ExpandableText from './heightExpand';
//@ts-ignore
import { Markdown, MarkMap } from '@/components';
//@ts-ignore
import { fetchMarkdownDataByType } from '@/api/tingWu';

const defaultPerson: { [key: string]: string } = { '1': person1, '2': person2, '3': person3, '4': person4 };
const { Panel } = Collapse;

interface DetailInherit extends Detail {
    chatbot_state?: 0 | 1;
    id?: any;
    local_source?: 0 | 1;
    ai_auth_state?: 0 | 1;
    source_id?: string;
    tenant_id?: string;
    name?: string;
    ai_translation_status?: string;
    target_languages?: string;
}

interface DetailResult extends RequestResult {
    data: DetailInherit;
}

interface Props {
    sourceId: string;
    paramsInfo: any;
    navigate: any;
    searchParams: any;
}

type IconType = 'keyWord' | 'chapter' | 'summary' | 'ppt' | 'point' | 'speechesSummary' | '' | undefined;

type CommonDataItemType = {
    file_url?: string;
    start?: number; //ppt文件数据集
    summary?: string; //ppt文件数据集
    end?: number; //ppt文件数据集
    vid?: number; //ppt文件数据集
    sentence_id?: number; //智能纪要
    text?: string; //智能纪要
    headline?: string; //章节速览（自动章节）
    chapter_start_time?: number;
    chapter_id?: number;
    changed?: boolean;
    headlineChanged?: boolean;
    summaryChanged?: boolean;
    v_id?: number;
};
type TaskIdType = { TaskId?: string };
//ppt文件数据集
// eslint-disable-next-line no-unused-vars
type PptExtractionDataType = {
    available_for_summary?: boolean;
    key_frame_list?: CommonDataItemType[];
    pdf_path?: string;
} & TaskIdType;
//智能纪要
type MeetingAssistanceDataType = {
    keywords?: string[];
    key_sentences?: CommonDataItemType[];
    classifications?: {
        Interview?: number;
        Lecture?: number;
        Meeting?: number;
    };
} & TaskIdType;
type ParagraphsItemType = {
    paragraph_id?: string;
    speaker_id?: string;
    words?: CommonDataItemType[]; //语音转写
    sentences?: CommonDataItemType[];
    start?: number;
    end?: number;
    indexSentenceId?: number;
    lastIndexSentenceId?: number;
};
//翻译
// eslint-disable-next-line no-unused-vars
type TranslationDataType = {
    paragraphs?: ParagraphsItemType[];
} & TaskIdType;
//章节速览（自动章节）
// eslint-disable-next-line no-unused-vars
type AutoChaptersDataType = CommonDataItemType[];
type AudioInfoType = {
    size?: number;
    duration?: number;
    sample_rate?: number;
};
//语音转写
// eslint-disable-next-line no-unused-vars
type TranscriptionDataType = {
    audio_info?: AudioInfoType;
    paragraphs?: ParagraphsItemType[];
} & TaskIdType;
type ConversationalSummaryItemType = {
    speaker_id?: string;
    speaker_name?: string;
    summary?: string;
    vid?: string;
    changed?: boolean;
};
type QuestionsAnsweringSummaryItemType = {
    question?: string;
    sentence_ids_of_question?: number[];
    answer?: string;
    sentence_ids_of_answer?: number[];
    speaker_id?: string[];
    paragraph_id?: string;
    vid?: string;
    questionChanged?: boolean;
    answerChanged?: boolean;
};
type MindMapSummaryList = {
    title?: string;
    children?: string[];
};
// eslint-disable-next-line no-unused-vars
type SummarizationDataType = {
    paragraph_summary?: string; //段落摘要
    conversational_summary_list?: ConversationalSummaryItemType[];
    mind_map_summary_list?: MindMapSummaryList[];
    questions_answering_summary_list?: QuestionsAnsweringSummaryItemType[];
} & TaskIdType;

export type AIDetailDataType = {
    data_type?: string;
    tr_id?: string;
    tenant_id?: string;
    resource_id?: string;
    task_id?: string;
    task_key?: string;
    mp3_path?: string;
    ppt_extraction?: PptExtractionDataType;
    meeting_assistance?: MeetingAssistanceDataType;
    translation?: TranslationDataType;
    auto_chapters?: AutoChaptersDataType;
    transcription?: TranscriptionDataType;
    summarization?: SummarizationDataType;
    update_time?: string;
    roles_enabled?: boolean;
};

interface AiDetailResult extends RequestResult {
    data: AIDetailDataType;
}

type KeywordTypeItem = { index?: number; name?: string };
type KeywordType = {
    all: KeywordTypeItem[];
    del?: KeywordTypeItem[];
    add?: KeywordTypeItem[];
};

interface FormData {
    keyword: KeywordType;
    summary: string;
    ppt_list: PptExtractionDataType;
    conversational_summary_list: ConversationalSummaryItemType[];
    questions_answering_summary_list: QuestionsAnsweringSummaryItemType[];
    mind_map_summary_list: MindMapSummaryList[];
    chapters: AutoChaptersDataType;
}

export enum Fade {
    // eslint-disable-next-line no-unused-vars
    In,
    // eslint-disable-next-line no-unused-vars
    Out
}

enum MDDataType {
    NULL,
    GOING,
    SUCCESS,
    FAIL
}

type QuestionsAnsweringSummaryMDDataType = {
    status?: MDDataType;
    content?: string;
};
type MindMapDataType = QuestionsAnsweringSummaryMDDataType;

interface MindMapDataTypeRequestResult extends RequestResult {
    data: MindMapDataType;
}

interface State {
    show: boolean;
    detail: DetailInherit;
    id?: string;
    aiDetail: AIDetailDataType;
    mindMapData?: MindMapDataType;
    mindMapType?: OPTIONS_TYPE;
    tabItems: TabsProps['items'] & any[];
    meetingAssistance: MeetingAssistanceDataType;
    autoChapters: AutoChaptersDataType;
    pptExtraction: PptExtractionDataType;
    summarization: SummarizationDataType;
    transcription: TranscriptionDataType;
    translation: TranslationDataType;
    questionsAnsweringSummaryType: OPTIONS_TYPE;
    questionsAnsweringSummaryMDData: QuestionsAnsweringSummaryMDDataType;
    currentTime?: number;
    lastSaveTime?: Date | number;
    paragraphId?: string;
    activeKey: string;
    activeCollapseKey: string;
    currKeyWord: string;
    playerOptions: any;
    clientOffSet: any;
    editTabType?: IconType;
    formData: FormData;
    isFirst: boolean;
    fade?: Fade;
    spin?: boolean;
    scrollContentFlag?: boolean;
    photoImages: { src?: string; key?: string }[];
    showPhoto?: boolean;
    photoIndex?: number;
    questionsParams?: any;
    ishowBackTop?: any;
    isEditing?: boolean;
    titleData?: string;
    languageValue?: string;
    isTranslateShow?: boolean;
    isRealTime?: boolean;
    translateLoading?: boolean;
    translateStatus?: number;
    searchText?: string;
    isExpanded?: boolean;
}

type DEFAULT_ITEM_TITLE_TYPE = {
    // eslint-disable-next-line no-unused-vars
    [key in keyof AIDetailDataType]: { title: string; sort: number };
} & {
    // eslint-disable-next-line no-unused-vars
    [name in keyof SummarizationDataType]: { title: string; sort: number };
};
let DEFAULT_ITEM_TITLE: DEFAULT_ITEM_TITLE_TYPE = {
    auto_chapters: { title: '章节速览', sort: 0 },
    summarization: { title: '发言总结', sort: 1 },
    questions_answering_summary_list: { title: '要点回顾', sort: 2 },
    ppt_extraction: { title: '提取PPT', sort: 3 },
    mind_map_summary_list: { title: '思维导图', sort: 4 }
};

enum OPTIONS_TYPE {
    Q_A_STYLE, //问答风格
    SIMPLE = 'minimal', //简洁
    DETAIL = 'detailed', //详细
    TUTORIAL = 'tutorial', //教程
    ACADEMIC = 'academic', //学术
    TASK_WIZARD = 'task_oriented', //任务向导
    MEETING_SUMMARY = 'meeting_minutes' //会议纪要
}

const DEFAULT_OPTIONS = [
    {
        value: OPTIONS_TYPE.Q_A_STYLE,
        label: '问答风格'
    },
    {
        value: OPTIONS_TYPE.SIMPLE,
        label: '精简'
    },
    {
        value: OPTIONS_TYPE.DETAIL,
        label: '详细'
    },
    {
        value: OPTIONS_TYPE.TUTORIAL,
        label: '教程'
    },
    {
        value: OPTIONS_TYPE.ACADEMIC,
        label: '学术'
    },
    {
        value: OPTIONS_TYPE.TASK_WIZARD,
        label: '任务导向'
    }
];
const DEFAULT_MIND_MAP_OPTIONS = cloneDeep(DEFAULT_OPTIONS).slice(1);
DEFAULT_MIND_MAP_OPTIONS.push({
    value: OPTIONS_TYPE.MEETING_SUMMARY,
    label: '会议纪要'
});

class SourceDetailAI extends Component<Props, State> {
    interval: number | undefined; // 声明 interval 属性
    state: State = {
        show: false,
        detail: {},
        aiDetail: {},
        tabItems: [],
        activeKey: '',
        meetingAssistance: {},
        questionsAnsweringSummaryType: OPTIONS_TYPE.Q_A_STYLE,
        questionsAnsweringSummaryMDData: {},
        mindMapType: OPTIONS_TYPE.SIMPLE,
        autoChapters: [],
        pptExtraction: {},
        summarization: {},
        transcription: {},
        translation: {},
        playerOptions: {},
        currKeyWord: '',
        activeCollapseKey: '1',
        clientOffSet: {},
        formData: {
            keyword: { all: [] },
            summary: '',
            ppt_list: {},
            conversational_summary_list: [],
            questions_answering_summary_list: [],
            mind_map_summary_list: [],
            chapters: []
        },
        isFirst: true,
        fade: Fade.Out,
        spin: true,
        scrollContentFlag: true,
        photoImages: [],
        showPhoto: false,
        photoIndex: 0,
        questionsParams: {
            id: this.props.sourceId
        },
        ishowBackTop: 0,
        isEditing: false,
        titleData: '',
        languageValue: 'no',
        isTranslateShow: false,
        translateLoading: false,
        translateStatus: 2,
        searchText: '',
        isExpanded: false
    };
    courseRef: any = null;
    inputRef = createRef<HTMLInputElement>();
    markMapRef = createRef<any>();
    selectSummaryTimer: number | null = null;
    mindTypeTimer: number | null = null;

    static getDerivedStateFromProps(nextProps: Props, prevState: State) {
        if (nextProps.sourceId && nextProps.sourceId !== prevState.id) {
            prevState.id = nextProps.sourceId;
            return prevState;
        }
        return null;
    }

    async getTranslationStatusFun(): Promise<DetailResult> {
        return Request.get(Request.baseUrl + getTranslationStatus + '?document_id=' + this.props.sourceId);
    }

    async fetchDetailData(): Promise<DetailResult> {
        return Request.get(Request.baseUrl + fileDetail + '?document_id=' + this.props.sourceId);
    }

    async fetchAIDetail(): Promise<AiDetailResult> {
        const data: AIDetailDataType = await Request.get(Request.baseUrl + aiDetail + '?resource_id=' + this.props.sourceId);
        return { data, success: true, code: '200', msg: '' };
    }

    fetchData() {
        Promise.all([this.fetchDetailData(), this.fetchAIDetail(), this.getTranslationStatusFun()]).then((res) => {
            const [sourceDetailResult, aiDetailResult, translationStatus] = res;
            let detail: Detail = {},
                aiDetail: AIDetailDataType = {};
            if (sourceDetailResult.success) {
                const { data } = sourceDetailResult;
                detail = data;
            } else {
                Toast.info(sourceDetailResult.msg || '服务请求发生错误');
            }
            if (aiDetailResult.success) {
                const { data } = aiDetailResult;
                aiDetail = data;
            }
            if (translationStatus.success) {
                this.setState(
                    {
                        translateStatus: Number(translationStatus?.data?.ai_translation_status),
                        languageValue: translationStatus?.data?.target_languages
                    },
                    () => {
                        // 在这里检查 translateStatus 并决定是否启动定时器
                        if (this.state.translateStatus === 1) {
                            this.startTranslationStatusCheck(); // 启动定时器
                        }
                    }
                );
            }
            const playerOptions: any = {
                    height: 368,
                    fluid: false
                },
                progressDot: any[] = [],
                autoChapters = aiDetail?.auto_chapters || [];
            if (autoChapters?.length) {
                for (const chapter of autoChapters) {
                    if (chapter?.v_id) {
                        let start = (chapter.start as number) / 1000,
                            duration = ((chapter.end as number) - (chapter.start as number)) / 1000;
                        progressDot.push({
                            time: start,
                            text: chapter.headline,
                            duration: duration
                        });
                    }
                }
                playerOptions.progressDot = progressDot;
            }
            this.setState(
                {
                    detail,
                    spin: false,
                    aiDetail,
                    isRealTime: aiDetail?.data_type === 'realtime',
                    playerOptions,
                    titleData: detail.name
                },
                () => {
                    this.fetchTabInfo();
                    this.initDataHandle();
                    const scrollableElement = document.querySelector('.ai-container');
                    // 监听滚动事件
                    if (scrollableElement) {
                        scrollableElement.addEventListener('scroll', () => {
                            // 获取滚动高度
                            const scrollTop = scrollableElement.scrollTop;
                            this.setState({ clientOffSet: { top: scrollTop } });
                        });
                    }
                }
            );
        });
    }

    initAIDataHandle() {
        let aiDetail: AIDetailDataType = {};
        this.fetchAIDetail().then((aiDetailResult) => {
            if (aiDetailResult.success) {
                const { data } = aiDetailResult;
                aiDetail = data;
            } else return;
            this.setState({ aiDetail }, () => {
                this.fetchTabInfo();
                this.initDataHandle();
            });
        });
    }

    fetchMindDataByType(type: OPTIONS_TYPE) {
        if (this.markMapRef.current?.markMapObj) {
            this.markMapRef.current?.markMapObj.destroy();
        }
        const handle = () =>
            fetchMarkdownDataByType(this.state.aiDetail.resource_id, type).then((res: any) => {
                const { success, data, msg } = res;
                if (success) {
                    const mindMapData = data;
                    if (data.status === MDDataType.SUCCESS) clearInterval(this.mindTypeTimer as number);
                    this.setState({ mindMapData });
                } else {
                    Toast.info(msg || '服务请求发生错误');
                    const mindMapData = { status: MDDataType.FAIL, content: '' };
                    clearInterval(this.mindTypeTimer as number);
                    this.setState({ mindMapData });
                }
            });
        this.mindTypeTimer = window.setInterval(handle, 1000);
        handle();
    }

    onChangeMindType(value: OPTIONS_TYPE) {
        this.setState({ mindMapType: value }, () => {
            clearInterval(this.mindTypeTimer as number);
            this.fetchMindDataByType(value);
        });
    }

    renderMindMap() {
        let result: ReactNode = '暂无数据';
        if (this.state.mindMapData?.status === MDDataType.SUCCESS) {
            return (
                <MarkMap
                    ref={this.markMapRef}
                    showOperator={true}
                    content={this.state.mindMapData?.content || ''}
                    toolbarSlot={
                        <Select
                            style={{ width: 142 }}
                            options={DEFAULT_MIND_MAP_OPTIONS}
                            onChange={this.onChangeMindType.bind(this)}
                            value={this.state.mindMapType}
                        />
                    }
                />
            );
        } else if (this.state.mindMapData?.status === MDDataType.FAIL)
            result = (
                <div
                    className={'ai-paragraph-tranFeil'}
                    style={{
                        border: 'none',
                        padding: '8px 0'
                    }}
                >
                    转录失败了，再试一次吧～
                </div>
            );
        else if (this.state.mindMapData?.status === MDDataType.GOING)
            result = (
                <div
                    className={'ai-paragraph-tranIng'}
                    style={{
                        border: 'none',
                        padding: '8px 0'
                    }}
                >
                    正在整理内容...
                </div>
            );
        return (
            <div className={'ai-paragraph-item-content'}>
                <Select
                    style={{ width: 142 }}
                    options={DEFAULT_MIND_MAP_OPTIONS}
                    onChange={this.onChangeMindType.bind(this)}
                    value={this.state.mindMapType}
                />
                {result}
            </div>
        );
    }

    initDataHandle() {
        let result = this.state.aiDetail,
            meetingAssistance = result?.meeting_assistance || {},
            autoChapters = result?.auto_chapters || [],
            pptExtraction = result?.ppt_extraction || {},
            summarization = result?.summarization || {},
            transcription = result?.transcription || {},
            translation = result?.translation || {},
            photoImages: any[] = [],
            formData: FormData = {
                keyword: { all: [] },
                summary: summarization?.paragraph_summary || '',
                ppt_list: {},
                conversational_summary_list: cloneDeep(summarization?.conversational_summary_list || []),
                questions_answering_summary_list: [],
                mind_map_summary_list: summarization?.mind_map_summary_list || [],
                chapters: cloneDeep(autoChapters)
            };
        if (meetingAssistance?.keywords && meetingAssistance?.keywords?.length) {
            const all = formData?.keyword?.all;
            meetingAssistance?.keywords?.forEach((item, index) => {
                all.push({ name: item, index });
            });
        }
        if (Object.keys(transcription).length && transcription?.paragraphs?.length) {
            const paragraphs = transcription?.paragraphs;
            for (const paragraph of paragraphs) {
                const words = paragraph?.words;
                if (words?.length) {
                    paragraph.start = words[0]?.start;
                    paragraph.end = words[words?.length - 1]?.end;
                    const index = words.findIndex((item) => item && item.hasOwnProperty('sentence_id'));
                    paragraph.indexSentenceId = words[index]['sentence_id'];
                    //@ts-ignore
                    const lastIndex = words.findLastIndex((item) => item && item.hasOwnProperty('sentence_id'));
                    paragraph.lastIndexSentenceId = words[lastIndex]['sentence_id'];
                }
            }
            transcription.paragraphs = paragraphs;
        }
        if (Object.keys(translation).length && translation?.paragraphs?.length) {
            const paragraphs = translation?.paragraphs;
            for (const paragraph of paragraphs) {
                const words = paragraph?.words;
                if (words?.length) {
                    paragraph.start = words[0]?.start;
                    paragraph.end = words[words?.length - 1]?.end;
                    const index = words.findIndex((item) => item && item.hasOwnProperty('sentence_id'));
                    paragraph.indexSentenceId = words[index]['sentence_id'];
                    //@ts-ignore
                    const lastIndex = words.findLastIndex((item) => item && item.hasOwnProperty('sentence_id'));
                    paragraph.lastIndexSentenceId = words[lastIndex]['sentence_id'];
                }
            }
            translation.paragraphs = paragraphs;
        }
        if (pptExtraction?.key_frame_list?.length) {
            const chapter_set: Set<number> = new Set();
            pptExtraction?.key_frame_list?.forEach((item) => {
                photoImages.push({ src: item.file_url, key: item.file_url });
                const start = item.start;
                autoChapters?.forEach((chapter) => {
                    if (
                        start &&
                        chapter &&
                        start >= (chapter?.start as number) &&
                        start <= (chapter?.end as number) &&
                        !chapter_set.has(chapter?.vid as number)
                    ) {
                        item.headline = chapter?.headline;
                        item.chapter_start_time = chapter?.start;
                        item.chapter_id = chapter?.vid;
                        chapter_set.add(chapter?.vid as number);
                    }
                });
            });
            formData.ppt_list = cloneDeep(pptExtraction);
        }
        if (summarization?.questions_answering_summary_list?.length) {
            const questionsAnsweringSummary = summarization?.questions_answering_summary_list;
            for (const questionsAnsweringSummaryElement of questionsAnsweringSummary) {
                if (questionsAnsweringSummaryElement?.sentence_ids_of_answer?.length) {
                    const start: number = questionsAnsweringSummaryElement?.sentence_ids_of_answer[0],
                        paragraphs = transcription?.paragraphs;
                    questionsAnsweringSummaryElement.speaker_id = [];
                    if (paragraphs?.length) {
                        for (const paragraph of paragraphs) {
                            if (
                                start &&
                                start >= (paragraph?.indexSentenceId as number) &&
                                start &&
                                start <= (paragraph?.lastIndexSentenceId as number)
                            ) {
                                questionsAnsweringSummaryElement.speaker_id.push(paragraph.speaker_id as string);
                                if (!questionsAnsweringSummaryElement?.paragraph_id && paragraph.paragraph_id)
                                    questionsAnsweringSummaryElement.paragraph_id = paragraph.paragraph_id;
                            }
                        }
                        questionsAnsweringSummaryElement.speaker_id = Array.from(new Set(questionsAnsweringSummaryElement.speaker_id));
                    }
                }
            }
            formData.questions_answering_summary_list = cloneDeep(summarization?.questions_answering_summary_list || []);
        }
        this.setState({
            formData,
            meetingAssistance,
            autoChapters,
            pptExtraction,
            summarization,
            transcription,
            translation,
            photoImages
        });
    }

    fetchTabInfo() {
        const aiDetail = this.state.aiDetail;
        const resultKeys = Object.keys(aiDetail),
            resultValues = Object.values(aiDetail),
            tabItems: TabsProps['items'] = [];
        let defaultKey: string = this.state.activeKey || '',
            isFirst: boolean = this.state.isFirst;
        if (resultKeys.length) {
            for (let i = 0, len = resultKeys.length; i < len; i++) {
                const item = resultKeys[i],
                    index = i,
                    //@ts-ignore
                    ite = DEFAULT_ITEM_TITLE[item];
                if (ite && resultValues[index]) {
                    if (resultValues[index].hasOwnProperty('questions_answering_summary_list')) {
                        tabItems.push({
                            key: 'questions_answering_summary_list',
                            //@ts-ignore
                            label: DEFAULT_ITEM_TITLE.questions_answering_summary_list['title'],
                            //@ts-ignore
                            sort: DEFAULT_ITEM_TITLE.questions_answering_summary_list['sort'],
                            type: 'questions_answering_summary_list'
                        });
                    }
                    tabItems.push({
                        key: item,
                        label: ite.title,
                        //@ts-ignore
                        sort: ite.sort,
                        type: item
                    });
                }
            }
            tabItems.push({
                key: 'mind_map_summary_list',
                //@ts-ignore
                label: DEFAULT_ITEM_TITLE.mind_map_summary_list['title'],
                //@ts-ignore
                sort: DEFAULT_ITEM_TITLE.mind_map_summary_list['sort'],
                type: 'mind_map_summary_list'
            });
        }
        if (tabItems.length) {
            //@ts-ignore
            const sortTabItems = tabItems.sort((curr, next) => curr.sort - next.sort);
            if (isFirst) defaultKey = sortTabItems[0]['key'];
            this.setState({ tabItems: sortTabItems, activeKey: defaultKey, isFirst: false });
            this.fetchMindDataByType(OPTIONS_TYPE.SIMPLE);
        }
    }

    componentDidMount() {
        this.fetchData();
        document.body.addEventListener('scroll', () => this.setState({ ishowBackTop: document.body.scrollTop }));
    }

    onTabClickHandle(key: string) {
        this.setState({ activeKey: key });
    }

    nowTimeFu(milliseconds: number) {
        let seconds = Math.floor(milliseconds / 1000);
        let minutes = Math.floor(seconds / 60);
        let hours = Math.floor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        return hours
            ? `${this.padZero(hours)}:${this.padZero(minutes)}:${this.padZero(seconds)}`
            : `${this.padZero(minutes)}:${this.padZero(seconds)}`;
    }

    // 函数用于在数字不足两位数时，在前面补零
    padZero(value: number) {
        return String(value).padStart(2, '0');
    }

    getSpeakerNameById(id: string) {
        const conversationalSummary = this.state.summarization?.conversational_summary_list;
        if (conversationalSummary?.length) {
            for (const item of conversationalSummary) {
                if (item['speaker_id'] && item['speaker_id'] === id) {
                    return item.speaker_name;
                }
            }
        }
        return null;
    }

    redirectChapter(data: CommonDataItemType) {
        if (this.state.editTabType === 'chapter') return;
        const start: number = data.start as number,
            currentTime = (data.start as number) / 1000,
            paragraphs = this.state.transcription?.paragraphs;
        this.setState({ currentTime }, () => {
            this.courseRef.currentTime = currentTime;
            let paragraphs_id: string = '';
            if (paragraphs && paragraphs?.length) {
                for (const paragraph of paragraphs) {
                    if (paragraph.start && start >= paragraph.start) {
                        paragraphs_id = paragraph.paragraph_id as string;
                        break;
                    }
                }
            }
            if (paragraphs_id) {
                const target = document.querySelector('div[data-paragraph-id="' + paragraphs_id + '"]');
                if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
        });
    }

    viewChapter(key: string) {
        this.setState({ activeCollapseKey: key === '0' ? '1' : key === '1' ? '0' : '' });
    }

    retrospectiveHandle(item: CommonDataItemType) {
        const start: number = item.start as number,
            currentTime = (item.start as number) / 1000;
        this.setState({ currentTime }, () => {
            this.courseRef.currentTime = currentTime;
            this.courseRef?.play();
            const paragraphs = this.state.transcription?.paragraphs;
            let paragraphs_id = '';
            if (paragraphs?.length) {
                for (const paragraph of paragraphs) {
                    if (paragraph.start && start >= paragraph.start) {
                        paragraphs_id = paragraph.paragraph_id as string;
                        break;
                    }
                }
            }
            if (paragraphs_id) {
                const target = document.querySelector('div[data-paragraph-id="' + paragraphs_id + '"]');
                if (target) target.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }
        });
    }

    renderAutoChapters() {
        const result: ReactNode[] = [],
            formData = this.state.formData,
            chapter = formData?.chapters;
        chapter?.forEach((item) => {
            result.push(
                <Timeline.Item key={item?.v_id} label={null}>
                    <Collapse
                        key={item?.v_id}
                        className={'chapter-collapse'}
                        onChange={() => this.redirectChapter(item)}
                        activeKey={this.state.activeCollapseKey}
                        bordered={false}
                        expandIcon={() => null}
                        // @ts-ignore
                        onClick={() => this.retrospectiveHandle(item)}
                    >
                        <Panel
                            header={
                                <div
                                    className={'ai-panel-header'}
                                    data-id={item.v_id}
                                    onMouseOver={(e: any) => setTimeout(() => e.target?.classList?.add('active'), 100)}
                                    onMouseOut={(e: any) => setTimeout(() => e.target?.classList?.remove('active'), 100)}
                                >
                                    <div
                                        className={'ai-panel-header-title'}
                                        dangerouslySetInnerHTML={{ __html: this.replaceEnter2Br(item.headline as string) }}
                                    ></div>
                                    {/* {
                            this.state.editTabType === 'chapter' ? null : <a className={'ai-panel-header-replay'}
                                                                             onClick={() => this.retrospectiveHandle(item)}
                                                                             onMouseOver={e => e.stopPropagation()}
                                                                             onMouseOut={e => e.stopPropagation()}>
                                <img width={'14px'} src={ai_replay}
                                     alt={''} />回顾</a>
                        } */}
                                </div>
                            }
                            key={'0'}
                            className="site-collapse-custom-panel"
                        >
                            <div
                                className={'ai-panel-header-lTitle'}
                                dangerouslySetInnerHTML={{ __html: this.replaceEnter2Br(item.summary as string) }}
                            ></div>
                        </Panel>
                    </Collapse>
                </Timeline.Item>
            );
        });
        const resultItems = this.state.activeCollapseKey === '0' ? result : result && result?.length > 2 ? result.slice(0, 2) : result;
        return (
            <div className="timeline_container">
                {result && result.length ? (
                    <div>
                        <Timeline mode={'left'}>{resultItems}</Timeline>
                        <div style={{ margin: '0 0 20px 45px', fontSize: '12px' }}>
                            <a style={{ color: '#3B70FF' }} onClick={() => this.viewChapter(this.state.activeCollapseKey)}>
                                {this.state.activeCollapseKey === '0' ? '收起' : '展开章节摘要'}
                            </a>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    fetchQuestionsAndAnswerMDData(type: OPTIONS_TYPE) {
        const handle = () =>
            fetchMarkdownDataByType(this.state.aiDetail.resource_id, type).then((res: any) => {
                const { success, data, msg } = res;
                if (success) {
                    const questionsAnsweringSummaryMDData = data;
                    if (data && data.status === MDDataType.SUCCESS) clearInterval(this.selectSummaryTimer as number);
                    this.setState({ questionsAnsweringSummaryMDData });
                } else {
                    Toast.info(msg || '服务请求发生错误');
                    const questionsAnsweringSummaryMDData = { status: MDDataType.FAIL, content: '' };
                    clearInterval(this.selectSummaryTimer as number);
                    this.setState({ questionsAnsweringSummaryMDData });
                }
            });
        handle();
        this.selectSummaryTimer = window.setInterval(handle, 1000);
    }

    changeSelectSummary(value: OPTIONS_TYPE) {
        this.setState({ questionsAnsweringSummaryType: value }, () => {
            clearInterval(this.selectSummaryTimer as number);
            if (value !== OPTIONS_TYPE.Q_A_STYLE) {
                this.fetchQuestionsAndAnswerMDData(value);
            }
        });
    }

    renderSummarization() {
        const conversationalSummary =
                this.state.formData?.conversational_summary_list && this.state.formData?.conversational_summary_list?.length
                    ? this.state.formData?.conversational_summary_list.sort((a, b) => {
                          return Number(a.speaker_id) - Number(b.speaker_id);
                      })
                    : this.state.formData?.conversational_summary_list,
            result: ReactNode[] = [];
        if (conversationalSummary?.length) {
            conversationalSummary.forEach((item) => {
                result.push(
                    <div
                        data-summary-item-id={item.vid}
                        className={'ai-summary-container-item' + (this.state.editTabType === 'point' ? ' edit' : '')}
                        key={item?.speaker_id}
                    >
                        <div className={'ai-summary-container-item-speaker'}>{this.getReviewSpeakerName(item?.speaker_id as string)}</div>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <div className={'ai-summary-container-item-summary'}>{item.summary}</div>
                        </div>
                    </div>
                );
            });
            return <div className={'ai-summary-container'}>{result}</div>;
        }
        return null;
    }

    renderPptExtraction() {
        const formData = this.state.formData;
        const ppt_list = formData?.ppt_list;
        const keyFrameList = ppt_list?.key_frame_list;
        const timelineItems: any = [];

        if (keyFrameList && keyFrameList.length) {
            keyFrameList.forEach((item, index) => {
                if (item.headline) {
                    timelineItems.push({
                        key: `${item?.chapter_id}_${index}`, // 唯一标识符
                        label: this.nowTimeFu(item.chapter_start_time || 0),
                        children: (
                            <div data-id={item.chapter_id} className={'ai-ppt-title'}>
                                {item.headline}
                            </div>
                        )
                    });
                }

                timelineItems.push({
                    key: `${item?.v_id}_${index}`, // 唯一标识符
                    label: this.nowTimeFu(item.start || 0),
                    children: (
                        <div data-ppt-id={item.v_id} className={`ai-ppt-content${this.state.editTabType === 'ppt' ? ' edit' : ''}`}>
                            <div style={{ position: 'relative' }}>
                                <img
                                    className={'ai-ppt-img'}
                                    onClick={() => this.setState({ showPhoto: true, photoIndex: index })}
                                    src={item.file_url}
                                    alt={item.file_url}
                                />
                            </div>
                            <div className={'ai-ppt-text'}>
                                <div data-id={item.v_id} dangerouslySetInnerHTML={{ __html: this.replaceEnter2Br(item.summary as string) }}></div>
                            </div>
                            <div>
                                <a
                                    className={'ai-panel-header-replay'}
                                    onClick={() => this.retrospectiveHandle(item)}
                                    onMouseOver={(e) => e.stopPropagation()}
                                    onMouseOut={(e) => e.stopPropagation()}
                                >
                                    <img width={'14px'} src={ai_replay} alt={''} />
                                    回顾
                                </a>
                            </div>
                        </div>
                    )
                });
            });
        }
        const displayedItems = this.state.isExpanded
            ? timelineItems
            : timelineItems && timelineItems?.length > 2
            ? timelineItems.slice(0, 2)
            : timelineItems;
        return (
            <div className="timeline_container timeline_container-ppt">
                <Timeline mode={'left'} items={displayedItems} />
                {timelineItems && timelineItems?.length > 2 ? (
                    <div
                        style={{ color: ' rgb(59, 112, 255)', cursor: 'pointer', marginLeft: '116px', fontSize: '12px' }}
                        onClick={() => this.setState((prevState) => ({ isExpanded: !prevState.isExpanded }))}
                    >
                        {this.state.isExpanded ? '收起' : '展开全部'}
                    </div>
                ) : null}
            </div>
        );
    }

    renderQuestionsAnsweringSummary() {
        const questionsAnsweringSummary = this.state.formData?.questions_answering_summary_list,
            result: ReactNode[] = [];
        if (questionsAnsweringSummary?.length) {
            questionsAnsweringSummary.forEach((item) => {
                result.push(
                    <div
                        data-ai-summary-review-id={item.vid}
                        className={'ai-summary-container-item-review' + (this.state.editTabType === 'speechesSummary' ? ' edit' : '')}
                        key={item?.question}
                    >
                        <img className={'ai-summary-point-icon'} src={point} alt={'要点'} />
                        <div
                            className={
                                this.state.editTabType === 'speechesSummary'
                                    ? 'ai-summary-point-content'
                                    : 'ai-summary-point-content ai-summary-point-contentEdit'
                            }
                            onClick={() => this.speechesSummaryScroll2View(item, this.state.editTabType)}
                        >
                            <div
                                className={'ai-summary-container-item-review-question'}
                                dangerouslySetInnerHTML={{ __html: item?.question as string }}
                            ></div>
                            <div
                                className={'ai-summary-container-item-review-answer'}
                                dangerouslySetInnerHTML={{ __html: item?.answer as string }}
                            ></div>
                            {/* <div
                            className={'ai-summary-container-item-review-speaker'}>{this.getReviewSpeakerName(item?.speaker_id as string[])}</div> */}
                        </div>
                        {/* <div style={{ width: 60 }}> {this.state.editTabType === 'speechesSummary' ? null :
                        <a className={'ai-speeches-summary-replay'}
                           onClick={() => this.speechesSummaryScroll2View(item)}>
                            <img width={14} src={ai_replay} alt={''} />回顾</a>}</div> */}
                    </div>
                );
            });
            return (
                <div className={'ai-summary-container new'}>
                    <div>
                        <Select
                            style={{ width: 142 }}
                            value={this.state.questionsAnsweringSummaryType}
                            options={DEFAULT_OPTIONS}
                            onChange={this.changeSelectSummary.bind(this)}
                        />
                    </div>
                    {this.state.questionsAnsweringSummaryType === OPTIONS_TYPE.Q_A_STYLE ? result : this.renderQuestionsAnsweringSummaryOtherType()}
                </div>
            );
        }
        return null;
    }

    renderQuestionsAnsweringSummaryOtherType() {
        if (this.state.questionsAnsweringSummaryMDData?.status === MDDataType.GOING) {
            return (
                <div className={'ai-paragraph-item-content'}>
                    <div
                        className={'ai-paragraph-tranIng'}
                        style={{
                            border: 'none',
                            padding: '8px 0'
                        }}
                    >
                        正在整理内容...
                    </div>
                </div>
            );
        } else if (this.state.questionsAnsweringSummaryMDData?.status === MDDataType.SUCCESS) {
            return <Markdown className={'render-md'} content={this.state.questionsAnsweringSummaryMDData.content || ''} />;
        } else if (this.state.questionsAnsweringSummaryMDData?.status === MDDataType.FAIL) {
            return (
                <div className={'ai-paragraph-item-content'}>
                    <div
                        className={'ai-paragraph-tranFeil'}
                        style={{
                            border: 'none',
                            padding: '8px 0'
                        }}
                    >
                        转录失败了，再试一次吧～
                    </div>
                </div>
            );
        }
        return '';
    }

    //@ts-ignore
    speechesSummaryScroll2View(data: QuestionsAnsweringSummaryItemType, isEdit) {
        if (isEdit === 'speechesSummary') return;
        this.setState({ paragraphId: data?.paragraph_id }, () => {
            this.scroll2View();
        });
    }

    getActiveContent() {
        const tabItems = this.state.tabItems,
            activeKey = this.state.activeKey;
        if (tabItems?.length) {
            let type = '';
            tabItems.forEach((item) => {
                //@ts-ignore
                if (item.key === activeKey) type = item.type;
            });
            if (type === 'auto_chapters') return this.renderAutoChapters();
            else if (type === 'summarization') return this.renderSummarization();
            else if (type === 'ppt_extraction') return this.renderPptExtraction();
            else if (type === 'questions_answering_summary_list') return this.renderQuestionsAnsweringSummary();
            else if (type === 'mind_map_summary_list') return this.renderMindMap();
        }
        return null;
    }

    getReviewSpeakerName(speakerIds: string[] | string) {
        const result: ReactNode[] = [];
        let index = 1;
        if (!Array.isArray(speakerIds)) speakerIds = [speakerIds];
        speakerIds?.map((item) => {
            if (index > 4) index = 1;
            if (this.state.aiDetail?.roles_enabled) {
                //@ts-ignore
                result.push(
                    <div key={defaultPerson['item'] ? defaultPerson[item] : defaultPerson[String(index)]} className={'point-speaker-item'}>
                        <img width={22} src={defaultPerson[item] ? defaultPerson[String(item)] : defaultPerson[String(index)]} alt={''} />
                        <span>{this.getSpeakerNameById(item)}</span>
                    </div>
                );
                //@ts-ignore
            } else
                result.push(
                    <div key={defaultPerson[item] ? defaultPerson[item] : defaultPerson[String(index)]} className={'point-speaker-item'}></div>
                );
            index++;
        });
        return result;
    }

    replaceEnter2Br(str: string) {
        return str ? str.replace(/\n/g, '<br>') : '';
    }

    getKeyWords(): ReactNode {
        const keyWords = this.state.formData?.keyword,
            all = keyWords?.all,
            result: ReactNode[] = [];
        if (all?.length) {
            all.map((item) => {
                result.push(
                    <span className={'key-words-item'} key={item.index} onClick={() => this.clickKeyWords(item.name as string)}>
                        {item.name}
                    </span>
                );
            });

            return (
                //@ts-ignore
                <ExpandableText maxLines={1} useExpanded={true} text={<div style={{ display: 'flex', flexWrap: 'wrap' }}>{result}</div>} />
            );
        }
        return null;
    }

    getSummary(): ReactNode {
        const summary = this.state.summarization;
        return (
            <div className={'ai-summary-content'}>
                <TextExpand
                    content={summary?.paragraph_summary}
                    maxLen={320}
                    contentRender={(text: string, handler: any) => {
                        return (
                            <>
                                <span
                                    style={{
                                        fontWeight: 400,
                                        fontSize: 14,
                                        color: 'rgba(0,0,0,0.7)'
                                    }}
                                >
                                    {text}
                                </span>
                                {handler}
                            </>
                        );
                    }}
                />
            </div>
        );
    }

    clickEditorHandle() {
        const sel = window.getSelection();
        if (sel) {
            const node = sel.focusNode || sel.anchorNode;
            if (node && node.parentElement) {
                const time = node.parentElement.getAttribute('data-time');
                if (time) {
                    let currentTime = Number(time) / 1000;
                    this.setState({ currentTime }, () => {
                        this.courseRef.currentTime = currentTime;
                    });
                }
            }
        }
    }

    getAllContent(): ReactNode {
        const transcription = this.state.transcription,
            auto_chapter = this.state.formData?.chapters,
            paragraphs = transcription?.paragraphs;
        const translation = this.state.translation,
            paragraphstranslation = translation?.paragraphs;
        if (!paragraphs?.length)
            return (
                <div className={'ai-paragraph-item-content'}>
                    <div className={'ai-paragraph-tranIng'} style={{ border: 'none', padding: '8px 0' }}>
                        似乎没有获取到有关信息
                    </div>
                </div>
            );
        //@ts-ignore
        let paragraphsArr: (ParagraphsItemType & { text?: string })[];
        //@ts-ignore
        if (paragraphs?.length && paragraphstranslation?.length) {
            paragraphsArr = paragraphs.map((firstItem) => {
                //@ts-ignore
                const match = paragraphstranslation.find((secondItem) => secondItem.paragraph_id === firstItem.paragraph_id);
                if (match) {
                    // 提取 sentences 中所有的 text
                    //@ts-ignore
                    const texts = match.sentences.map((sentence) => sentence.text).join(' ');
                    return { ...firstItem, text: texts }; // 更新 txt 属性
                }
                return firstItem; // 如果没有匹配则返回原始项
            });
        } else {
            //@ts-ignore
            paragraphsArr = paragraphs;
        }
        //@ts-ignore
        if (paragraphsArr?.length) {
            const result: ReactNode[] = [],
                chapterMap: Map<number, any> = new Map();
            paragraphsArr.forEach((item, index) => {
                const paragraphId = item.paragraph_id,
                    speakerId = item.speaker_id,
                    words = item.words,
                    start = item.start,
                    end = item.end,
                    //@ts-ignore
                    text = item.text;
                if (auto_chapter?.length && start) {
                    const chapterIndex = auto_chapter.findIndex((chapter) => {
                        return (chapter?.start as number) <= start && (chapter?.end as number) >= Number(end);
                    });
                    if (chapterMap.get(chapterIndex)) {
                        const value = chapterMap.get(chapterIndex);
                        value.push(index);
                    } else chapterMap.set(chapterIndex, [index]);
                }
                if (words?.length) {
                    let wordsDir: ReactNode[] = [],
                        start: number = 0;
                    for (let i = 0, len = words.length; i < len; i++) {
                        const ite = words[i];
                        if (i === 0) start = ite.start as number;
                        if (paragraphId === this.state.paragraphId && (ite.start as number) <= (this.state.currentTime || 0) * 1000) {
                            wordsDir.push(
                                <span
                                    data-time={ite.start}
                                    data-time-range={ite.start + '-' + ite.end}
                                    data-sentence-id={ite.sentence_id}
                                    data-id={ite.v_id}
                                    className={'payload'}
                                    key={ite.v_id}
                                >
                                    {ite.text && ite.text === this.state.currKeyWord ? (
                                        <span className={'searched active'}>{ite.text}</span>
                                    ) : (
                                        ite.text
                                    )}
                                </span>
                            );
                        } else
                            wordsDir.push(
                                <span
                                    data-time={ite.start}
                                    data-time-range={ite.start + '-' + ite.end}
                                    data-sentence-id={ite.sentence_id}
                                    data-id={ite.v_id}
                                    key={ite.v_id}
                                >
                                    {ite.text && ite.text === this.state.currKeyWord ? (
                                        <span className={'searched active'}>{ite.text}</span>
                                    ) : (
                                        ite.text
                                    )}
                                </span>
                            );
                    }
                    result.push(
                        <div
                            className={'ai-paragraph-item'}
                            data-speaker-id={item.speaker_id}
                            data-paragraph-id={paragraphId}
                            id={String(start)}
                            key={paragraphId}
                        >
                            <div className={'ai-paragraph-item-header'}>
                                {this.getReviewSpeakerName(speakerId as string)}
                                <span className={'ai-paragraph-item-header-time'}>{this.nowTimeFu(start)}</span>
                            </div>
                            <div className={'ai-paragraph-item-content' + (paragraphId === this.state.paragraphId ? ' active-paragraphOther' : '')}>
                                <div
                                    className={'ai-paragraph-editor'}
                                    data-paragraph-id={paragraphId}
                                    data-speaker-id={speakerId}
                                    onClick={this.clickEditorHandle.bind(this)}
                                >
                                    {wordsDir}
                                </div>
                                {this.state.languageValue === 'no' ? null : this.state.translateStatus === 2 ? (
                                    <div className={'ai-paragraph-tran'}>{text}</div>
                                ) : this.state.translateStatus === 1 ? (
                                    <div className={'ai-paragraph-tranIng'}>加载中...</div>
                                ) : this.state.translateStatus === 3 ? (
                                    <div className={'ai-paragraph-tranFeil'}>翻译失败</div>
                                ) : null}
                            </div>
                        </div>
                    );
                } else {
                    result.push(
                        <div
                            className={'ai-paragraph-item'}
                            data-speaker-id={item.speaker_id}
                            data-paragraph-id={paragraphId}
                            id={String(start)}
                            key={paragraphId}
                        >
                            <div className={'ai-paragraph-item-header'}>
                                {this.getReviewSpeakerName(speakerId as string)}
                                <span className={'ai-paragraph-item-header-time'}>{start ? this.nowTimeFu(start as number) : ''}</span>
                            </div>
                            <div className={'ai-paragraph-item-content' + (paragraphId === this.state.paragraphId ? ' active-paragraphOther' : '')}>
                                <div
                                    className={'ai-paragraph-editor'}
                                    data-paragraph-id={paragraphId}
                                    data-speaker-id={speakerId}
                                    onClick={this.clickEditorHandle.bind(this)}
                                ></div>
                                <div></div>
                            </div>
                        </div>
                    );
                }
            });
            return (
                <Timeline mode={'left'} className="timeline_container">
                    {result.map((short, index) => (
                        //@ts-ignore
                        <Timeline.Item key={index} label={''}>
                            {short}
                        </Timeline.Item>
                    ))}
                </Timeline>
            );
        }
        return null;
    }

    scroll2View() {
        const paragraphId = this.state.paragraphId,
            target = document.querySelector('[data-paragraph-id="' + paragraphId + '"]');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }

    scroll2Top() {
        document.querySelector('.admin-layout')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    clickKeyWords(keyWords: string) {
        const punctuationRegex = /[\u3002\uff1b\uff0c\uff1a\u201c\u201d\uff08\uff09\u300a\u300b\u2018\u2019\uff1f\uff01.,:;'"()?!]/g;
        let keyWord = keyWords;
        let transcription = this.state.transcription,
            paragraphs = transcription.paragraphs;
        let paragraphId: string = '';
        let flagOther = false;
        if (paragraphs?.length) {
            for (const paragraph of paragraphs) {
                let words = paragraph.words,
                    flag: boolean = false;

                if (words?.length) {
                    let continueFlag = false,
                        continueArray: number[] = [];
                    for (let i = 0, len = words.length; i < len; i++) {
                        const word = words[i];
                        let wordOther = word.text as string;
                        if (word && word.text && word.text === keyWord) {
                            if (!flag) {
                                if (!flagOther) {
                                    paragraphId = paragraph.paragraph_id || '';
                                }
                                flag = true;
                                flagOther = true;
                            }
                            continueFlag = false;
                            continueArray = [];
                        } else if (keyWord.indexOf(wordOther) !== -1) {
                            continueFlag = true;
                            continueArray.push(i);
                        } else if (word && punctuationRegex.test(wordOther) && keyWord.indexOf(wordOther.replace(punctuationRegex, '')) !== -1) {
                            const match = wordOther.match(punctuationRegex);
                            if (match && match.length) {
                                continueFlag = true;
                                continueArray.push(i);
                            }
                        } else if (wordOther.includes(keyWord)) {
                            continueFlag = true;
                            continueArray.push(i);
                        } else {
                            continueFlag = false;
                            continueArray = [];
                        }
                        if (continueFlag && continueArray.length) {
                            const newKeyWordArr = continueArray.map((item) => words && words[item]?.text),
                                newWords = newKeyWordArr && newKeyWordArr.length ? newKeyWordArr.join('') : '',
                                replaceKeyword = newWords.replace(punctuationRegex, '');
                            if (replaceKeyword && replaceKeyword === keyWord) {
                                if (!flag) {
                                    if (!paragraphId) {
                                        paragraphId = paragraph.paragraph_id || '';
                                    }
                                    flag = true;
                                    flagOther = true;
                                }
                                if (replaceKeyword !== newWords) {
                                    const match = wordOther.match(punctuationRegex);
                                    if (match?.length) {
                                        const index = wordOther.indexOf(match[0]);
                                        if (index === 0) {
                                            word.text = word?.text?.replace(punctuationRegex, '');
                                            words?.splice(
                                                i - 1,
                                                0,
                                                Object.assign({}, word, {
                                                    text: match[0],
                                                    vid: Number(word?.vid) - 1
                                                })
                                            );
                                        } else if (index === wordOther.length - 1) {
                                            word.text = word?.text?.replace(punctuationRegex, '');
                                            words?.splice(
                                                i + 1,
                                                0,
                                                Object.assign({}, word, {
                                                    text: match[0],
                                                    vid: Number(word?.vid) + 1
                                                })
                                            );
                                        }
                                    }
                                } else {
                                    words.splice(continueArray[0], continueArray.length, {
                                        sentence_id: words[continueArray[0]]?.sentence_id,
                                        start: words[continueArray[0]]?.start,
                                        end: words[continueArray[continueArray.length - 1]]?.end,
                                        text: replaceKeyword,
                                        vid: words[continueArray[0]]?.vid
                                    });
                                }
                                i -= continueArray.length;
                                len -= continueArray.length;
                                continueFlag = false;
                                continueArray = [];
                                flag = false;
                            } else if (replaceKeyword.includes(keyWord)) {
                                let parts = replaceKeyword.split(keyWord);
                                let result: string[] = [];
                                for (let i = 0; i < parts.length; i++) {
                                    result.push(parts[i]);
                                    if (i < parts.length - 1 || parts[i] !== '') {
                                        result.push(keyWord);
                                    }
                                }
                                if (parts[parts.length - 1] === '') {
                                    result.pop();
                                }
                                result = result.filter((part) => part !== '');
                                if (result.length) {
                                    const startIndex = continueArray[0];
                                    const currentVid = Number(words[startIndex]?.vid) || 0;
                                    const newWordsArray = result.map((text, index) => ({
                                        text,
                                        vid: currentVid + index
                                    }));
                                    words.splice(startIndex, continueArray.length, ...newWordsArray);
                                    i -= continueArray.length;
                                    len -= continueArray.length;
                                    continueFlag = false;
                                    continueArray = [];
                                    flag = false;
                                }
                            }
                        }
                    }
                }
            }
        }
        this.setState({ currKeyWord: keyWord, transcription }, () => {
            if (paragraphId) {
                const target = document.querySelector('[data-paragraph-id="' + paragraphId + '"]');
                if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    }

    registerPlayerMethod(player: any) {
        this.courseRef = player;
        const playTime = this.props.searchParams?.get('t');
        if (playTime) this.courseRef.currentTime = Number(playTime);
        // const openAiStartTime = localStorage.getItem('openAiStartTime');
        // if (openAiStartTime) {
        //     localStorage.removeItem('openAiStartTime');
        //     this.courseRef.currentTime = Number(openAiStartTime) / 1000;
        // }
        player.onTimeUpdate = () => {
            const currentTime: number = player.currentTime,
                transcription = this.state.transcription;
            let paragraphId: string = '';
            if (transcription && transcription?.paragraphs && transcription?.paragraphs?.length) {
                const paragraphs = transcription?.paragraphs;
                for (const paragraph of paragraphs) {
                    if ((paragraph.start as number) <= currentTime * 1000 && (paragraph.end as number) >= currentTime * 1000) {
                        paragraphId = paragraph.paragraph_id || '';
                        break;
                    }
                }
                if (this.state.paragraphId !== paragraphId) {
                    if (this.state.scrollContentFlag) {
                        const target = document.querySelector('[data-paragraph-id="' + paragraphId + '"]');
                        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'end' });
                    }
                }
                this.setState({ currentTime, paragraphId });
            }
        };
        player.off('seeked', () => {
            console.debug('seeked canceled');
        });
        player.on('seeked', () => {
            const currentTime: number = player.currentTime,
                transcription = this.state.transcription;
            let paragraphId: string = '';
            if (transcription && transcription?.paragraphs && transcription?.paragraphs?.length) {
                const paragraphs = transcription?.paragraphs;
                for (const paragraph of paragraphs) {
                    if ((paragraph.start as number) <= currentTime * 1000 && (paragraph.end as number) >= currentTime * 1000) {
                        paragraphId = paragraph.paragraph_id || '';
                        break;
                    }
                }
                if (paragraphId) {
                    const target = document.querySelector('[data-paragraph-id="' + paragraphId + '"]');
                    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'end' });
                }
            }
        });
        player.on('end', () => {
            this.setState({ currentTime: 0, paragraphId: '' });
        });
    }

    initPlayer(player: any) {
        if (player) this.registerPlayerMethod(player);
    }

    removeKeyWordHandle(name: string, index: number) {
        const formData = this.state.formData,
            keyword = formData?.keyword;
        if (keyword?.del && keyword?.del?.length) keyword.del.push({ index, name });
        else keyword.del = [{ index, name }];
        //当使用forEach遍历数组并同时修改数组时，可能会导致意外的行为。在这种情况下，当你尝试删除一个元素时，数组的长度会减少，但是forEach会继续遍历原始长度的数组，这可能导致跳过某些元素或者访问不存在的元素
        keyword.all = keyword.all.filter((item) => item.index !== index);
        if (keyword?.add && keyword?.add.length) {
            keyword.add = keyword.add.filter((item) => item.index !== index);
        }
        this.setState({ formData });
    }

    randomKey: number = Math.floor(Math.random() * 1000);

    onPressEnterHandle(e: KeyboardEvent<HTMLInputElement>) {
        //@ts-ignore
        const value: string = e.target?.value,
            formData = this.state.formData,
            keyWords = formData?.keyword,
            all = keyWords.all,
            add = keyWords?.add;
        if (value) {
            let index = 1;
            if (all && all?.length) {
                let last = all[all.length - 1];
                index = last.index ? last.index + 1 : 1;
            }
            let item: KeywordTypeItem = { name: value, index };
            all.push(item);
            if (add && add?.length) add.push(item);
            else if (!add) keyWords.add = [item];
        }
        this.setState({ formData }, () => {
            //@ts-ignore
            e.target.value = '';
            this.randomKey = Math.floor(Math.random() * 1000);
        });
    }

    renderAIKeyWordHeader() {
        return (
            <div className={'ai-key-word-header'}>
                <p className={'ai-title'}>关键字</p>
            </div>
        );
    }

    renderAISummaryHeader() {
        return (
            <div className={'ai-key-word-header'}>
                <p className={'ai-title'}>全文概要</p>
            </div>
        );
    }

    // @ts-ignore
    copyImg(file_url: string): Promise<ClipboardItem> {
        return new Promise((resolve) => {
            const canvas = document.createElement('canvas'),
                ctx = canvas.getContext('2d'),
                img = new Image();
            canvas.width = 150;
            canvas.height = 85;
            img.crossOrigin = 'Anonymous';
            img.src = file_url;
            img.onload = () => {
                ctx?.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
                ctx?.drawImage(img, 0, 0);
                //将canvas转为blob
                canvas.toBlob(async (blob) => {
                    //@ts-ignore
                    resolve(new ClipboardItem({ 'image/png': blob }));
                });
            };
        });
    }

    fadeToggle(fade: Fade) {
        if (fade === Fade.In) {
            const ele = document.querySelector('.ai-container');
            if (ele) ele.classList.add('fadeOut');
        } else if (fade === Fade.Out) {
            const ele = document.querySelector('.ai-container');
            if (ele) ele.classList.remove('fadeOut');
        }
        this.setState({ fade });
    }

    //@ts-ignore
    async fetchUpdateTitle(name) {
        return Request.put(Request.baseUrl + updateTitle + '/' + this.props.sourceId, {
            document_name: name
        });
    }

    //@ts-ignore
    async fetchTranslation(languages) {
        return Request.put(Request.baseUrl + getTranslation + '?document_id=' + this.props.sourceId + '&target_languages=' + languages);
    }

    async fetchGetDelete() {
        let arr = [this.props.sourceId];
        const data = await Request.delete(Request.baseUrl + getDelete, {
            document_ids: arr
        });
        return { data, success: true, code: '200', msg: '' };
    }

    handleEditClick = () => {
        this.setState({ isEditing: true }, () => {
            //@ts-ignore
            this.inputRef.current.focus();
        });
    };

    handleInputChange = (event: any) => {
        this.setState({ titleData: event.target.value });
    };
    handleBlur = () => {
        this.setState({ isEditing: false });
        if (!this.state.titleData || !this.state.titleData.trim()) {
            this.setState({ titleData: this.state.detail.name });
            return Toast.info('请输入标题');
        }
        this.fetchUpdateTitle(this.state.titleData).then((res) => {
            //@ts-ignore
            if (res && !res?.success) {
                this.setState((prevState) => ({
                    detail: {
                        ...prevState.detail, // 保持其他属性
                        name: this.state.detail.name // s新 name
                    },
                    titleData: this.state.detail.name
                }));
                //@ts-ignore
                Toast.info(res?.msg || '服务请求发生错误');
            } else {
                //@ts-ignore
                this.setState((prevState) => ({
                    detail: {
                        ...prevState.detail, // 保持其他属性
                        name: this.state.titleData // s新 name
                    }
                }));
                Toast.info('操作成功');
            }
        });
    };

    handleSearch = (event: any) => {
        this.setState({ searchText: event.target.value });
    };

    onSearch = () => {
        this.clickKeyWords(this.state.searchText as string);
    };

    componentWillUnmount() {
        clearInterval(this.interval); // 清除定时器
        clearInterval(this.selectSummaryTimer as number);
        clearInterval(this.mindTypeTimer as number);
    }

    startTranslationStatusCheck = () => {
        this.getTranslationStatusLx();
        // @ts-ignore
        this.interval = window.setInterval(() => {
            this.getTranslationStatusLx();
        }, 5000); // 每隔 5 秒调用一次
    };
    getTranslationStatusLx = () => {
        this.getTranslationStatusFun().then((res) => {
            if (res && res.success) {
                //@ts-ignore
                this.setState({
                    translateStatus: Number(res?.data?.ai_translation_status),
                    languageValue: res?.data?.target_languages
                });
                //@ts-ignore
                if (res.data?.ai_translation_status === 2 || res.data?.ai_translation_status === 3) {
                    clearInterval(this.interval); // 清除定时器
                    this.fetchData();
                }
            }
        });
    };
    handleLanguageValue = (val: string) => {
        this.setState({ translateLoading: true });
        this.fetchTranslation(val).then((res) => {
            //@ts-ignore
            if (res && res?.success) {
                Toast.info('操作成功');
                this.setState({ languageValue: val, isTranslateShow: false, translateLoading: false });
                this.startTranslationStatusCheck();
            } else {
                //@ts-ignore
                Toast.info(res.msg || '服务请求发生错误');
                this.setState({ translateLoading: false });
            }
        });
    };

    translateShowBtn = () => {
        this.setState({ isTranslateShow: !this.state.isTranslateShow });
    };

    returnBtn = () => {
        this.props.navigate(`/web/o/${this.props.paramsInfo?.agentId}/tools/${this.props.paramsInfo?.toolId}`);
    };

    deleteOutBtn = () => {
        ConfirmTip({
            icon: null,
            title: '删除',
            content: (
                <div
                    style={{
                        color: '#333333',
                        fontSize: '16px',
                        margin: '25px 0 40px',
                        lineHeight: '20px',
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    <ExclamationCircleOutlined style={{ color: '#FF8A39', fontSize: '20px', marginRight: '17px' }} />
                    确定删除本记录吗?
                </div>
            ),
            okText: '删除',
            className: 'deleteBox',
            onOk: () => {
                this.fetchGetDelete().then((res) => {
                    //@ts-ignore
                    if (res && res?.success) {
                        Toast.info('操作成功');
                        this.returnBtn();
                    } else {
                        //@ts-ignore
                        Toast.info(res.msg || '服务请求发生错误');
                    }
                });
            }
        });
    };

    render() {
        //@ts-ignore
        return (
            <>
                <div className={'ai-content-body'}>
                    {this.state.spin ? (
                        <div className={'content-spin-loading'}>
                            <Spin spinning={this.state.spin} size={'large'} fullscreen />
                        </div>
                    ) : (
                        <>
                            <div className={'ai-content-body-left'}>
                                <div className={'ai-content-body-header'}>
                                    <div className={'ai-header-box'}>
                                        <div className={'ai-content-body-header-title'}>
                                            <div className={'outlinedBtn'} onClick={this.returnBtn.bind(this)}>
                                                <LeftOutlined />
                                            </div>
                                            {this.state.isEditing ? (
                                                <Input
                                                    type="text"
                                                    value={this.state.titleData}
                                                    onChange={this.handleInputChange.bind(this)}
                                                    onBlur={this.handleBlur.bind(this)}
                                                    //@ts-ignore
                                                    ref={this.inputRef}
                                                    maxLength={50}
                                                    className={'ai-input-edit'}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            e.preventDefault();
                                                            this.handleBlur();
                                                        }
                                                    }}
                                                />
                                            ) : (
                                                <span className={'nameText'} onClick={this.handleEditClick}>
                                                    {this.state.detail?.name}
                                                </span>
                                            )}
                                        </div>

                                        <div className={'ai-header-search'}>
                                            <Input
                                                className={'searchInput'}
                                                addonBefore={<SearchOutlined style={{ cursor: 'pointer' }} onClick={this.onSearch.bind(this)} />}
                                                onPressEnter={this.onSearch.bind(this)}
                                                placeholder="请输入关键字"
                                                maxLength={50}
                                                onChange={this.handleSearch.bind(this)}
                                                value={this.state.searchText}
                                            />

                                            {this.state.translateStatus === 1 ? (
                                                <SyncOutlined spin style={{ fontSize: '18px', margin: '0 20px' }} />
                                            ) : this.state.isRealTime ? null : (
                                                <div className={'ai-header-tran'}>
                                                    {/* <TranslationOutlined onClick={this.translateShowBtn.bind(this)} style={{fontSize:'16px',color:'#999',marginRight:'10px'}}/> */}
                                                    <div className={'translatioItem'} onClick={this.translateShowBtn.bind(this)}></div>
                                                    <Display show={this.state.isTranslateShow}>
                                                        <div className={'ai-header-language'}>
                                                            <p className={'translatioItem-title'}>翻译</p>
                                                            <div className={'translatioItem-sel'}>
                                                                <div className={'translatioItem-lang'}>选择语言</div>
                                                                <Select
                                                                    style={{ width: 120, marginRight: 8 }}
                                                                    onChange={this.handleLanguageValue.bind(this)}
                                                                    value={this.state.languageValue}
                                                                >
                                                                    {languageOptionsInfo.map((option) => (
                                                                        <Select.Option key={option.value} value={option.value}>
                                                                            {option.label}
                                                                        </Select.Option>
                                                                    ))}
                                                                </Select>
                                                            </div>
                                                        </div>
                                                    </Display>
                                                </div>
                                            )}
                                            <div className={'deleteIcon'} onClick={this.deleteOutBtn.bind(this)}></div>
                                        </div>
                                    </div>
                                    <div></div>
                                </div>
                                <div className={'ai-content-video' + (this.state.fade === Fade.In ? ' hide' : '')}>
                                    {
                                        //@ts-ignore
                                        this.state.detail?.type ? (
                                            <ViewSource
                                                tokenUrl={Request.baseUrl + '/user/document/v1/vod/asset-token/'}
                                                className={'source-detail'}
                                                detail={this.state.detail}
                                                playerOptions={this.state.playerOptions}
                                                initPlayer={this.initPlayer.bind(this)}
                                            />
                                        ) : null
                                    }
                                </div>
                                <div className={'ai-content-video-fade'}>
                                    {this.state.fade === Fade.In ? (
                                        <img onClick={() => this.fadeToggle(Fade.Out)} src={fadeOut} alt={'展开'} />
                                    ) : (
                                        <img onClick={() => this.fadeToggle(Fade.In)} src={fadeIn} alt={'收起'} />
                                    )}
                                </div>
                                <div className={'ai-content-split'}>
                                    <div className={'ai-content-split-content'}>
                                        <div className={'ai-split-left'}></div>
                                        <div className={'ai-content-title'}>
                                            智能内容由 AI 模型生成，我们不对内容准确性和完整性做任何保证，亦不代表我们的观点或态度
                                        </div>
                                        <div className={'ai-split-right'}></div>
                                    </div>
                                </div>
                                <div className={'body_wrapper' + (this.state.fade === Fade.In ? ' body_wrapperHide' : '')}>
                                    <div>
                                        <div style={{ display: 'flex', marginBottom: '32px' }}>
                                            <img src={ai_title} width={95} height={24} />{' '}
                                        </div>
                                    </div>
                                    {this.state.formData?.keyword?.all?.length > 0 ? (
                                        <div className={'ai-key-words'}>
                                            {this.renderAIKeyWordHeader()}
                                            <div>{this.getKeyWords()}</div>
                                        </div>
                                    ) : null}
                                    {this.state?.summarization?.paragraph_summary ? (
                                        <div className={'ai-summary'}>
                                            {this.renderAISummaryHeader()}
                                            <div>{this.getSummary()}</div>
                                        </div>
                                    ) : null}
                                    {this.state.tabItems?.length > 0 ? (
                                        <div className={'ai-tab-content'}>
                                            <div className={'ai-tab-content-tabs'}>
                                                <Tabs
                                                    activeKey={this.state.activeKey}
                                                    items={this.state.tabItems}
                                                    onTabClick={this.onTabClickHandle.bind(this)}
                                                />
                                            </div>
                                            <div className={'item-content'}>{this.getActiveContent()}</div>
                                        </div>
                                    ) : null}
                                    <div>
                                        <div className={'ai-summary-all'}>
                                            <div className={'ai-summary-all-title'}>
                                                <img src={ai_content} alt={''} />
                                                <p className={'ai-title'}>原文</p>
                                            </div>
                                            <div className={'ai-summary-all-content'}>{this.getAllContent()}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={'side-tool'}>
                                <div className={'tool-top-curr'}>
                                    <Tooltip title={'回到当前播放位置'} placement={'right'}>
                                        <AimOutlined onClick={this.scroll2View.bind(this)} className={'side-tool-icon'} />
                                    </Tooltip>
                                </div>
                                {this.state.ishowBackTop > 50 ? (
                                    <div className={'tool-top-curr'} style={{ position: 'fixed', bottom: '35px' }}>
                                        <Tooltip title={'回到顶部'} placement={'right'}>
                                            <VerticalAlignTopOutlined className={'side-tool-icon'} onClick={this.scroll2Top.bind(this)} />
                                        </Tooltip>
                                    </div>
                                ) : null}
                            </div>
                        </>
                    )}
                </div>
                {this.state.photoImages?.length ? (
                    <PhotoSlider
                        images={this.state.photoImages.map((item) => ({ src: item.src, key: item.key })) as any}
                        visible={this.state.showPhoto as boolean}
                        onClose={() => this.setState({ showPhoto: false })}
                        index={this.state.photoIndex as number}
                        onIndexChange={(index) => this.setState({ photoIndex: index })}
                    />
                ) : null}
            </>
        );
    }
}

const App = (props: any) => {
    const { grtAi } = props.store;
    const paramsInfo = useParams(),
        paramsId = paramsInfo.toolDetail as string,
        [searchParams] = useSearchParams();
    const [isCheckCanUse, setIsCheckCanUse] = useState(false);
    const [isToolTw, setIsToolTw] = useState(false);
    const navigate = useNavigate();
    const goLogin = () => {
        let redirect = `${window.location.href}`;
        window.location.href = `${origin}/login?redirect=${redirect}`;
    };
    const checkIsLogin = async () => {
        const res = await grtAi.checkLogin();
        if (res) {
            return true;
        }
        Toast.info('请登录');
        setTimeout(() => {
            goLogin();
        }, 500);
        return false;
    };
    const checkCanUseFun = async () => {
        const res = await grtAi.checkCanUseStudy(paramsInfo.agentId);
        if (!res || !res.success || !res.data) {
            Toast.info('该智能体未对外开放使用，请联系管理员');
            setIsCheckCanUse(true);
        }
    };
    useEffect(() => {
        const toolData = grtAi?.state?.currentAgent?.scene_tool;
        if (toolData && toolData.length > 0) {
            // @ts-ignore
            const exists = toolData.some((tool) => tool.tool_id === 1 || tool.tool_id === '1');

            if (!exists) {
                Toast.info('该智能体未对外开放使用，请联系管理员');
                return setIsToolTw(true);
            }
            setIsToolTw(false);
        } else {
            setIsToolTw(true);
            Toast.info('该智能体未对外开放使用，请联系管理员');
        }
        checkIsLogin();
        checkCanUseFun();
    }, []);
    return (
        <>
            <div className={'wrapper'} style={{ width: '100%' }}>
                <Display show={isCheckCanUse || isToolTw}>
                    <div className={'isCheckCanUse'}></div>
                </Display>
                <SourceDetailAI key={paramsId} sourceId={paramsId} paramsInfo={paramsInfo} searchParams={searchParams} navigate={navigate} />
            </div>
        </>
    );
};
export default withRouter(inject('store')(observer(App)));
